export const wizardStatusItems = {
  DRAFT: { key: 'Draf', label: 'Draf' },
  CONFIRMED: { key: 'Dikonfirmasi', label: 'Dikonfirmasi' },
  EXPIRED: { key: 'Kadaluwarsa', label: 'Kadaluwarsa' },
  CANCELED: { key: 'Dibatalkan', label: 'Dibatalkan' },
  CLOSED: { key: 'Ditutup', label: 'Ditutup' },
}

export const wizardOrderItems = {
  Temporary: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.EXPIRED,
  ],
  Draf: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.EXPIRED,
  ],
  Dikonfirmasi: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.EXPIRED,
  ],
  Kadaluwarsa: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.EXPIRED,
  ],
  Dibatalkan: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.CANCELED,
  ],
  Ditutup: [
    wizardStatusItems.DRAFT,
    wizardStatusItems.CONFIRMED,
    wizardStatusItems.CLOSED,
  ],
}